import { GridCustomCellProps } from "@progress/kendo-react-grid";

const PhoneCell = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;
  const phone = props.dataItem[props.field];
  return (
    <td {...props.tdProps}>
      <a href={`tel:${phone}`} className="text-primary">{phone}</a>
    </td>
  );
}

export default PhoneCell;